import { useTranslation } from 'react-i18next'
import { cn } from '@asad/crane-ui'

import { ALERT_STATUS_CONFIG, WORKING_CONFIG } from '../config/statusConfig'
import type { DeviceAlertStatus } from '../types'

export type StatusChipProps = {
  alertStatus: DeviceAlertStatus
  variant?: 'dot' | 'solid'
  size?: 'sm' | 'md'
  withIcon?: boolean
  className?: string
}

/** Etykieta zagregowanego stanu alarmowego urządzenia. */
export const StatusChip = ({
  alertStatus,
  variant = 'dot',
  size = 'md',
  withIcon = false,
  className,
}: StatusChipProps) => {
  const { t } = useTranslation()
  const config = ALERT_STATUS_CONFIG[alertStatus]
  const { Icon } = config

  const marker = withIcon ? (
    <Icon className={variant === 'solid' ? 'size-3' : 'size-3.5'} aria-hidden />
  ) : (
    <span className={cn('size-2 rounded-crane-sm', config.dot)} aria-hidden />
  )

  if (variant === 'solid') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 rounded-crane-sm font-semibold',
          size === 'sm' ? 'px-2 py-0.5 text-crane-xs' : 'px-2.5 py-1 text-xs',
          config.bg,
          config.text,
          className,
        )}
      >
        {marker}
        {t(config.labelKey)}
      </span>
    )
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 font-semibold',
        size === 'sm' ? 'text-crane-xs' : 'text-xs',
        config.text,
        className,
      )}
    >
      {marker}
      {t(config.labelKey)}
    </span>
  )
}

export type PowerChipProps = {
  isWorking: number
  className?: string
}

/** Etykieta stanu włączenia urządzenia, niezależna od jego stanu alarmowego. */
export const PowerChip = ({ isWorking, className }: PowerChipProps) => {
  const { t } = useTranslation()
  const config = WORKING_CONFIG[isWorking ? 'on' : 'off']
  const { Icon } = config

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-crane-sm px-2.5 py-1 text-xs font-semibold',
        config.bg,
        config.text,
        className,
      )}
    >
      <Icon className='size-3' aria-hidden />
      {t(config.labelKey)}
    </span>
  )
}
